// js
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';


function UsageHeaderNav({area, areas, dsa, activeAreaIds, baseNavRoute}) {
  const previousAreaId = area && activeAreaIds && activeAreaIds[activeAreaIds.indexOf(area.id) - 1];
  const previousArea = areas.find(a => a.id === previousAreaId);
  const nextAreaId = area && activeAreaIds && activeAreaIds[activeAreaIds.indexOf(area.id) + 1];
  const nextArea = areas.find(a => a.id === nextAreaId);

  return (
    <div className='header-wrapper'>
      {!!area &&
        <div className='next-prev-links'>
          {previousArea &&
            <Link
              to={`${baseNavRoute}/usage/${previousArea.id}`}
              className='prev-link'>&#60; Previous: {previousArea.title}
            </Link>
          }
          {dsa && !previousArea &&
            <Link
              to={`${baseNavRoute}/usage`}
              className='prev-link'>&#60; Previous: Overview
            </Link>
          }
          {nextArea &&
            <Link
              to={`${baseNavRoute}/usage/${nextArea.id}`}
              className='next-link'>Next: {nextArea.title} &#62;
            </Link>
          }
          {dsa && !nextArea &&
            <Link
              to={`${baseNavRoute}/sources`}
              className='next-link'>Next: Sources &#62;
            </Link>
          }
        </div>
      }
    </div>
  );
}

UsageHeaderNav.propTypes = {
  area: PropTypes.object,
  areas: PropTypes.array,
  dsa: PropTypes.object,
  activeAreaIds: PropTypes.array,
  baseNavRoute: PropTypes.string.isRequired
};

export default UsageHeaderNav;



// WEBPACK FOOTER //
// ./src/components/usage/UsageHeaderNav.js